<h4 *ngIf="isLaunched && !loaded">Iniciando...</h4>
<app-caller-patient-panel *ngIf="isLaunched && loaded"></app-caller-patient-panel>

<div *ngIf="!isLaunched" (click)="init()">

    <h1>Haga click en la pantalla para iniciar llamador</h1>

</div>